export const ENV_KEY = 'CONO-EDITOR';
export const ROLE = 'frankrom_admin';
